import * as babelPolyfill from 'babel-core/polyfill';
import * as fetchPolyfill from 'whatwg-fetch';

/*
 * Uncomment the Bootstrap modules you would like to use within your code.
 */

// import * as bsAffix from 'bootstrap/js/affix.js';
// import * as bsAlert from 'bootstrap/js/alert.js';
// import * as bsTooltip from 'bootstrap/js/tooltip.js';
// import * as bsButton from 'bootstrap/js/button.js';
// import * as bsCarousel from 'bootstrap/js/carousel.js';
// import * as bsCollapse from 'bootstrap/js/collapse.js';
// import * as bsDropdown from 'bootstrap/js/dropdown.js';
// import * as bsModal from 'bootstrap/js/modal.js';
// import * as bsPopover from 'bootstrap/js/popover.js';
// import * as bsScrollspy from 'bootstrap/js/scrollspy.js';
// import * as bsTab from 'bootstrap/js/tab.js';
// import * as bsTransition from 'bootstrap/js/transition.js';


/** WEBPACK FOOTER **
 ** ./src/vendors.jsx
 **/